__turbopack_context__.v({
  "blink": "ProjectFeatured-module-scss-module__V6BvLG__blink",
  "content": "ProjectFeatured-module-scss-module__V6BvLG__content",
  "hasImage": "ProjectFeatured-module-scss-module__V6BvLG__hasImage",
  "hidden": "ProjectFeatured-module-scss-module__V6BvLG__hidden",
  "image": "ProjectFeatured-module-scss-module__V6BvLG__image",
  "imageContainer": "ProjectFeatured-module-scss-module__V6BvLG__imageContainer",
  "imageFull": "ProjectFeatured-module-scss-module__V6BvLG__imageFull",
  "imageHover": "ProjectFeatured-module-scss-module__V6BvLG__imageHover",
  "projectFeatured": "ProjectFeatured-module-scss-module__V6BvLG__projectFeatured",
});
